import styled from "styled-components";
import ApplicantFlow from "../../utils/applicantflow";
import ScoreFlow from "../../utils/scoreflow";
import Reveal from "react-awesome-reveal";
import { slideFade } from "../../utils/animations";
// import DashboardFlow from "../../utils/dashboardflow";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -9vw;
  width: 100%;
  height: 100%;
  gap: 4rem;
  padding: 3rem;
  align-items: center;
`;

const ListItem = styled.div`
  display: flex;
  width: 100%;
  gap: calc(min(5rem, 15vw) * 2);
  align-items: center;
  justify-content: center;

  > div {
    width: min(420px, 80vw);
  }

  @media (max-width: 900px) {
    gap: 1rem;
    flex-direction: column-reverse !important;

    > div {
      max-width: 80vw;
    }
  }
`;

// const ListItemVertical = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   align-items: center;
// `;

// const Title = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   margin-top: clamp(-5rem, -5vw, -6rem);
//   gap: 20px;

//   > div {
//     font-size: min(3rem, 10vw);
//     font-weight: bold;
//     color: #333;
//   }

//   > span {
//     font-family: "Funnel Sans", sans-seri;
//     text-align: left;
//     font-size: min(1.5rem, 5vw);
//     align-content: center;
//   }
// `;

const Heading = styled.h1`
  font-family: "Funnel Sans", sans-seri;
  font-size: min(5rem, 10vw);
  font-weight: bold;
  color: #333;
`;

function Flow1() {
  return (
    <Container id="why-smarcuit">
      <Reveal keyframes={slideFade} fraction={0.1}>
        <Heading>Why Choose Smarcuit?</Heading>
        <ListItem>
          <ApplicantFlow />
          <div>
            <h1>AI That Understands Skills</h1>
            <span>
              Smarcuit learns the candidates and the role. It asks real
              questions, instead of guessing from resumes or keywords. <br />
              <br />
              <b>No assumptions. No hacks. Just clarity.</b>
            </span>
          </div>
        </ListItem>
        <ListItem style={{ flexDirection: "row-reverse" }}>
          <ScoreFlow />
          <div>
            <h1>Faster, Cleaner & Reliable</h1>
            <span>
              Every candidate is scored against the role, not a keyword list.
              Teams see the best matches immediately without sifting through
              noise. <br />
              <br />
              <b>Better signals. Faster decisions.</b>
            </span>
          </div>
        </ListItem>
      </Reveal>
      {/* <ListItemVertical>
        <DashboardFlow />
        <Reveal keyframes={slideFade} duration={1500}>
          <Title>
            <div>Beta Launching January 2026</div>
            <span>
              Join the waiting list for our beta & Help us build a new standard.
            </span>
            <button
              onClick={() => {
                window.location.href = "/join";
              }}
            >
              Try Early
            </button>
          </Title>
        </Reveal>
      </ListItemVertical> */}
    </Container>
  );
}

export default Flow1;
